import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/userContext';
import ROLES from '../common/roles';

export default function DashboardRedirect() {
    const [{ user, loading }] = useAuth();
    if (loading) return null;
    switch (user.role) {
        case ROLES.ADMIN:
            return <Navigate to="/dashboard/admin" replace />;
        case ROLES.OWNER:
            return <Navigate to="/dashboard/owner" replace />;
        case ROLES.MANAGER:
        case ROLES.SENIOR_MANAGER:
        default:
            return <Navigate to="/dashboard/manager" replace />;
    }
}
